const trainingsStart =  state => {
    return state.todos.filter(todo => todo.done)
}

export default {
    trainingsStart
};